import styles from '../../index.module.scss'
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import Utils from '@utils/utils'
import { TYPETITLEMAP, IMAGE_TYPE, CLOTH_COLOR_TYPE } from '@utils/CONST'

const ModelLeftCom = (props) => {
    const { item, selectedInputImg, setSelectedInputImg } = props

    const title = (
        <>
            <p className={styles.title}>{item?.projectName}</p>
            <p>{(item?.imageType == IMAGE_TYPE.CLOTH_RECOLOR && item.mode == CLOTH_COLOR_TYPE.CLOTH_RECOLOR) ? '自由换色' :
                (item?.imageType == IMAGE_TYPE.CLOTH_RECOLOR && item.mode == CLOTH_COLOR_TYPE.SIM_RECOLOR) ? '同款换色' :
                    TYPETITLEMAP[item?.imageType]}</p>
            <p>{item?.createdTime}</p>
        </>
    )

    const mode = (
        <p style={{ marginBottom: '24px' }}>{item?.mode == 'std' ? '标准模式' : '高品质模式'}</p>
    )
    const skinRefine = (
        <p>肤质高清·开启</p>
    )
    const relight = (
        <p>光影融合·开启</p>
    )
    const recolor = (
        <>
            <p>目标颜色：{item.color}</p>
            <span style={{
                display: 'inline-block',
                backgroundColor: item.color,
                width: '64px',
                height: '64px',
                borderRadius: '8px',
                verticalAlign: 'middle',
            }}>
            </span>
        </>
    )

    const simReColor = (
        <>
            <p>衣服平铺图</p>
            <div className={styles.inputImg}>
                {
                    item?.clothes?.split(',').map((inputItem) => {
                        return <img
                            key={inputItem}
                            onClick={() => setSelectedInputImg(inputItem)}
                            src={Utils.getImgThumbnail(inputItem)} alt="" />

                    })
                }
            </div>
        </>
    )
    const inputImg = (
        <>
            <p>{item?.imageType == IMAGE_TYPE.CLOTHES ? '衣服平铺图' : '输入图'}</p>
            <div className={styles.inputImg}>
                {
                    item?.inputImage?.split(',').map((inputItem) => {
                        return <img
                            className={(selectedInputImg == inputItem && item?.inputImage?.split(',').length > 1) ? styles.inputImgSelected : ''}
                            key={inputItem}
                            onClick={() => setSelectedInputImg(inputItem)}
                            src={Utils.getImgThumbnail(inputItem)} alt="" />

                    })
                }
            </div>
        </>
    )
    const poseImg = (
        <>
            <p>试衣参考图</p>
            <img src={Utils.getImgThumbnail(item?.pose?.url)} alt="" />
        </>
    )
    const poseTryonImg = (
        <>
            <p>{item?.poseRef?.custom ? "自定义参考图" : '预设参考图'}</p>
            <img src={Utils.getImgThumbnail(item?.poseRef?.url)} alt="" />
        </>
    )
    const glassesTryonImg = (
        <>
            <p>{item?.glassesRef?.custom ? "自定义参考图" : '预设参考图'}</p>
            <img src={Utils.getImgThumbnail(item?.glassesRef?.url)} alt="" />
        </>
    )
    const simTryonImg = (
        <>
            <p>{item?.poseRef?.custom ? "自定义参考图" : '预设参考图'}</p>
            <img src={Utils.getImgThumbnail(item?.poseRef?.url)} alt="" />
        </>
    )
    const modelImg = (
        <>
            {item?.keepPose ? null : <p>模特图：{
                item?.person?.custom ? "自定义模特" :
                    item?.person?.title?.split("-").pop()}</p>}

            {!item?.keepPose && <img src={Utils.getImgThumbnail(item?.person?.url)} alt="" />}
        </>
    )

    const bkgImg = (
        <>
            {
                item?.keepBkg ? null : <p>背景图：{
                    item?.background?.custom ? "自定义背景" :
                        item?.background?.title?.split("-").pop()}</p>
            }
            {!item?.keepBkg && <img src={Utils.getImgThumbnail(item?.background?.url)} alt="" />}
        </>
    )

    const shoesImg = (
        <>
            <p>{item?.shoesRef?.custom ? "自定义参考图" : '预设参考图'}</p>
            <img src={Utils.getImgThumbnail(item?.shoesRef?.url)} alt="" />
        </>
    )


    const showConent = (
        item?.imageType == IMAGE_TYPE.CLOTHES ? (
            <>
                {title}
                {mode}
                {inputImg}
                {poseImg}
                {modelImg}
                {bkgImg}
            </>
        ) : item?.imageType == IMAGE_TYPE.MODEL ?
            (
                <>
                    {title}
                    {item?.skinRefine ? skinRefine : null}
                    {item?.relight > 0 ? relight : null}
                    {inputImg}
                    {modelImg}
                    {bkgImg}
                </>
            ) : item?.imageType == IMAGE_TYPE.SHOES ?
                (
                    <>
                        {title}
                        {mode}
                        {inputImg}
                        {shoesImg}
                    </>
                ) : item?.imageType == IMAGE_TYPE.MODEL_VIDEO ?
                    (
                        <>
                            {title}
                            {inputImg}
                        </>
                    ) : item?.imageType == IMAGE_TYPE.COMMODITYRECOLOR ?
                        (
                            <>
                                {title}
                                {recolor}
                            </>
                        ) : item?.imageType == IMAGE_TYPE.CLOTH_RECOLOR ?
                            (
                                <>
                                    {title}
                                    {inputImg}
                                    {(item.mode == CLOTH_COLOR_TYPE.CLOTH_RECOLOR ? recolor : simReColor)}
                                </>
                            ) : item?.imageType == IMAGE_TYPE.COMMODITY ?
                                (
                                    <>
                                        {title}
                                        {inputImg}
                                        {bkgImg}
                                    </>
                                ) : item?.imageType == IMAGE_TYPE.POSE_TRYON ?
                                    (
                                        <>
                                            {title}
                                            {inputImg}
                                            {poseTryonImg}
                                        </>
                                    ) : item?.imageType == IMAGE_TYPE.GLASSES_TRYON ?
                                        (
                                            <>
                                                {title}
                                                {inputImg}
                                                {glassesTryonImg}
                                            </>
                                        ) : item?.imageType == IMAGE_TYPE.SIM_TRYON ?
                                            (
                                                <>
                                                    {title}
                                                    {inputImg}
                                                    {simTryonImg}
                                                </>
                                            ) : (
                                                <>
                                                    {title}
                                                    {inputImg}
                                                </>
                                            )
    )





    return (
        <div className={`${styles.ModelLeftCom} _beauty_scrollbar`}>
            {showConent}
        </div>
    )
}

export default ModelLeftCom